import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckMochilaService {
  private data = null;
  private url = environment.serviceApi;

  constructor(public http: Http) { }


  getChecksMochila() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmochila')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }
  
  getChecksMochilaByUsuario(usuario) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmochila/usuario/' + usuario)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getChecksMochilaByRegiao(usuario) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmochila/regiao/' + usuario)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getCheckMochila(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmochila/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaCheckMochila(data) {

    console.log("[criaCheckMochila]");
    console.log("[data.produtos]" , data.produtos);

    return new Promise((resolve, reject) => {
      this.http.post(this.url + '/checkmochila', {
        check_mochila_data: data.check_mochila_data,
        check_mochila_registro: data.check_mochila_registro,
        check_mochila_status: data.check_mochila_status,
        check_mochila_turno:  data.check_mochila_turno,
        cliente_id: data.cliente_id,
        mochila_id: data.mochila_id,
        profissional_id:  data.profissional_id,
        unidade_id: data.unidade_id,
        usuario_id: data.usuario_id,
        veiculo_id: data.veiculo_id,
        cor_veiculo_nome: data.cor_veiculo_nome,
        produtos: data.produtos
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  editaCheckMochila(data) {
    return new Promise((resolve, reject) => {
      this.http.put(this.url + '/checkmochila/' + data.check_mochila_id, {
        check_mochila_data: data.check_mochila_data,
        check_mochila_registro: data.check_mochila_registro,
        check_mochila_status: data.check_mochila_status,
        check_mochila_turno:  data.check_mochila_turno,
        cliente_id: data.cliente_id,
        mochila_id: data.mochila_id,
        profissional_id:  data.profissional_id,
        unidade_id: data.unidade_id,
        usuario_id: data.usuario_id,
        veiculo_id: data.veiculo_id,
        cor_veiculo_nome: data.cor_veiculo_nome,
        produtos: data.produtos
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  apagaCheckMochila(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.url + '/checkmochila/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  apagaCheckMochilaAdmin(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.url + '/checkmochila/admin/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }
}
